import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const driverNotificationPreferencesAdapter = getAdapter({ idFieldName: 'value' });

const driverNotificationPreferencesSlice = createSlice({
  name: 'driverNotificationPreferences',
  initialState: driverNotificationPreferencesAdapter.getInitialState({
    source: null,
  }),
  reducers: {
    setDriverNotificationPreferences: (state, { payload: { driverNotificationPreferences, source } }) => {
      driverNotificationPreferencesAdapter.setAll(state, driverNotificationPreferences);
      state.source = source;
    },
  },
});

const selectors = driverNotificationPreferencesAdapter.getSelectors(
  ({ driverNotificationPreferences }) => driverNotificationPreferences,
);


export const { setDriverNotificationPreferences } = driverNotificationPreferencesSlice.actions;

export default driverNotificationPreferencesSlice.reducer;
